import React from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { Toaster } from 'sonner';

// Pages
import Landing from './pages/Landing';
import Search from './pages/Search';
import PropertyDetail from './pages/PropertyDetail';
import Auth from './pages/Auth';
import PartnerDashboard from './pages/partner/Dashboard';
import AdminDashboard from './pages/admin/Dashboard';
import CustomerDashboard from './pages/customer/Dashboard';
import BookingConfirmation from './pages/BookingConfirmation';

// Protected route
const ProtectedRoute = ({ element, allowedRoles }) => {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FAFAF9]">
        <div className="text-center">
          <div className="w-8 h-8 border-2 border-gold border-t-transparent rounded-full animate-spin mx-auto mb-3" />
          <p className="text-gray-400 text-sm">Loading...</p>
        </div>
      </div>
    );
  }
  if (!user) return <Navigate to="/auth" replace />;
  if (allowedRoles && !allowedRoles.includes(user.role)) return <Navigate to="/" replace />;
  return element;
};

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/search" element={<Search />} />
      <Route path="/property/:id" element={<PropertyDetail />} />
      <Route path="/auth" element={<Auth />} />
      <Route path="/partner" element={
        <ProtectedRoute element={<PartnerDashboard />} allowedRoles={['Partner', 'Admin']} />
      } />
      <Route path="/partner/*" element={
        <ProtectedRoute element={<PartnerDashboard />} allowedRoles={['Partner', 'Admin']} />
      } />
      <Route path="/admin" element={
        <ProtectedRoute element={<AdminDashboard />} allowedRoles={['Admin']} />
      } />
      <Route path="/admin/*" element={
        <ProtectedRoute element={<AdminDashboard />} allowedRoles={['Admin']} />
      } />
      <Route path="/customer" element={
        <ProtectedRoute element={<CustomerDashboard />} allowedRoles={['Customer', 'Partner', 'Admin']} />
      } />
      <Route path="/booking/:bookingId" element={<BookingConfirmation />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <div className="App">
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </div>
    </AuthProvider>
  );
}

export default App;
